var map = {
	"./account-balance.svg": [
		42574,
		2574
	],
	"./add-person.svg": [
		7019,
		7019
	],
	"./addDocument.svg": [
		27150,
		7150
	],
	"./arrow-down.svg": [
		95231,
		5231
	],
	"./arrow-left.svg": [
		82811,
		2811
	],
	"./arrow-right.svg": [
		1899,
		1899
	],
	"./bill.svg": [
		6733,
		6733
	],
	"./boleto.svg": [
		35577,
		5577
	],
	"./calendar.svg": [
		67854,
		7854
	],
	"./cancel-recharge.svg": [
		49173,
		9173
	],
	"./card.svg": [
		78348,
		8348
	],
	"./cart-empty.svg": [
		99156,
		9156
	],
	"./cart-not-empty.svg": [
		17814,
		7814
	],
	"./check-circle-green.svg": [
		82251,
		2251
	],
	"./check-circle-outlined.svg": [
		34108,
		4108
	],
	"./check-circle.svg": [
		38513,
		8513
	],
	"./circle-plus.svg": [
		1807,
		1807
	],
	"./close-filled.svg": [
		54706,
		4706
	],
	"./confirm-recharge.svg": [
		50266,
		266
	],
	"./copy.svg": [
		92845,
		2845
	],
	"./credit-card.svg": [
		28542,
		8542
	],
	"./document.svg": [
		8273,
		8273
	],
	"./dollar.svg": [
		85152,
		5152
	],
	"./download.svg": [
		78346,
		4038
	],
	"./edit.svg": [
		86779,
		6779
	],
	"./email-outlined.svg": [
		98869,
		8869
	],
	"./email.svg": [
		97728,
		7728
	],
	"./error.svg": [
		3397,
		3397
	],
	"./export.svg": [
		13610,
		3610
	],
	"./external-link.svg": [
		98411,
		8411
	],
	"./file-download.svg": [
		18301,
		8301
	],
	"./filter.svg": [
		30532,
		532
	],
	"./finance.svg": [
		43835,
		3835
	],
	"./grupo.svg": [
		24329,
		4329
	],
	"./home.svg": [
		57965,
		8264
	],
	"./instagram.svg": [
		30026,
		26
	],
	"./key.svg": [
		5310,
		5310
	],
	"./link.svg": [
		66421,
		6421
	],
	"./linkedin-rect.svg": [
		85859,
		5859
	],
	"./location.svg": [
		99180,
		9180
	],
	"./md-card.svg": [
		18346,
		8346
	],
	"./meal.svg": [
		91944,
		1944
	],
	"./ok.svg": [
		48810,
		8810
	],
	"./options-outline-svgrepo-com.svg": [
		45026,
		5026
	],
	"./pencil-recharge.svg": [
		81269,
		1269
	],
	"./people-fill.svg": [
		83491,
		3491
	],
	"./pin.svg": [
		24811,
		4811
	],
	"./pix.svg": [
		68332,
		8332
	],
	"./power.svg": [
		89935,
		9935
	],
	"./qr-code.svg": [
		21654,
		1654
	],
	"./qrcode-finished.svg": [
		93317,
		3317
	],
	"./receipt.svg": [
		63528,
		3528
	],
	"./recharge.svg": [
		60281,
		281
	],
	"./repeat.svg": [
		671,
		671
	],
	"./request-list.svg": [
		70752,
		752
	],
	"./search.svg": [
		32105,
		2105
	],
	"./shopping-cart.svg": [
		71224,
		1224
	],
	"./signatures.svg": [
		57547,
		7547
	],
	"./slash.svg": [
		75489,
		5489
	],
	"./spinner-pix-copy.svg": [
		85054,
		5054
	],
	"./spinner.svg": [
		28643,
		8643
	],
	"./step-disabled.svg": [
		19001,
		9001
	],
	"./team.svg": [
		26835,
		6835
	],
	"./telephone-fill.svg": [
		86217,
		6217
	],
	"./transport.svg": [
		83114,
		3114
	],
	"./trash-2.svg": [
		29072,
		9072
	],
	"./trash-recharge.svg": [
		42067,
		2067
	],
	"./trash.svg": [
		41470,
		1470
	],
	"./triangle.svg": [
		97194,
		7194
	],
	"./twitter-bird.svg": [
		77465,
		7465
	],
	"./upload.svg": [
		23035,
		3035
	],
	"./user-settings.svg": [
		40632,
		632
	],
	"./warning.svg": [
		73447,
		3447
	],
	"./x.svg": [
		24062,
		4062
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 56838;
module.exports = webpackAsyncContext;